import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import configuration from './modules/configuration';
import registration from './modules/registration';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    configuration,
    registration,
  },
  strict: true,
  plugins: [createPersistedState({ storage: window.sessionStorage })],
});

export default store;
